import { render, staticRenderFns } from "./popup-choose-source.vue?vue&type=template&id=f3af79ae&scoped=true"
import script from "./popup-choose-source.vue?vue&type=script&lang=js"
export * from "./popup-choose-source.vue?vue&type=script&lang=js"
import style0 from "./popup-choose-source.vue?vue&type=style&index=0&id=f3af79ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af79ae",
  null
  
)

export default component.exports